// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { getAPIConfig } from '@tcp/core/src/utils';
import { cleanUpUrl, getImageSource } from '../utils/DamImageUtils';
import { StyledImage } from '../DamImage.styles';

const defaultImageCrop = 'w_auto,f_auto,q_auto';

// eslint-disable-next-line sonarjs/cognitive-complexity
const ImageTag = (props) => {
  const {
    src,
    crop,
    altText,
    overrideStyle,
    className,
    tabIndex,
    onLoad,
    backgroundStyle,
    lazyLoadImage,
    fwdRef,
    selectedPDPImage,
    pinchZoomImagePage,
    isPDP,
    fromQv,
  } = props;

  const url = cleanUpUrl(src);
  const { assetHostTCP: assetHost } = getAPIConfig();
  const imgSource = getImageSource(assetHost, crop, url, src);
  const [imageURL, setImageURL] = useState(selectedPDPImage || imgSource);
  const [imageURLUpdate, setImageURLUpdate] = useState('');
  const [loadingImage, setLoadIngImage] = useState(
    pinchZoomImagePage && !selectedPDPImage && (isPDP || fromQv)
  );
  const onLoadImage = () => {
    setLoadIngImage(false);
    onLoad();
  };

  const loadImageAndSetState = (imageUrl) => {
    const image = new Image();
    image.src = imageUrl;

    image.onload = () => {
      // Image is fully loaded
      setImageURL(imageUrl); // Set the state with the loaded image URL
    };

    image.onerror = (error) => {
      // Handle errors if the image fails to load
      console.error('Failed to load the image:', error);
    };
  };

  useEffect(() => {
    if (pinchZoomImagePage && !selectedPDPImage && !loadingImage && imgSource !== imageURLUpdate) {
      setImageURLUpdate(imgSource);
      setLoadIngImage(true);
    }
  }, [imgSource]);

  useEffect(() => {
    if (selectedPDPImage) {
      loadImageAndSetState(imgSource);
    }
  }, []);

  const stylesImageComponent = () => {
    return (
      <StyledImage
        ref={fwdRef}
        overrideStyle={overrideStyle}
        src={selectedPDPImage ? imageURL : imgSource}
        alt={altText}
        className={className}
        tabIndex={tabIndex}
        onLoad={onLoadImage}
        loading={lazyLoadImage ? 'lazy' : ''}
        {...(backgroundStyle ? { style: backgroundStyle } : {})}
      />
    );
  };
  return pinchZoomImagePage && (isPDP || fromQv) ? (
    <div className={loadingImage ? 'is-hidden' : 'is-visible'}>{stylesImageComponent()}</div>
  ) : (
    stylesImageComponent()
  );
};

ImageTag.propTypes = {
  src: PropTypes.string.isRequired,
  crop: PropTypes.string,
  altText: PropTypes.string,
  overrideStyle: PropTypes.string,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  backgroundStyle: PropTypes.shape({}),
  isProductImage: PropTypes.bool,
  lazyLoadImage: PropTypes.bool,
  pinchZoomImagePage: PropTypes.bool,
  isPDP: PropTypes.bool,
};

ImageTag.defaultProps = {
  crop: defaultImageCrop,
  altText: 'Image alt text',
  overrideStyle: '',
  className: '',
  onLoad: () => null,
  backgroundStyle: null,
  isProductImage: false,
  lazyLoadImage: false,
  pinchZoomImagePage: false,
  isPDP: false,
};

export default ImageTag;
